import { render } from "./VoyageContent.vue?vue&type=template&id=68a2f6c1"
import script from "./VoyageContent.vue?vue&type=script&lang=js"
export * from "./VoyageContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__